export interface LegacyPpcWeek {
  number?: number
  longNumber?: number
  percentItems?: number | null
  percentWorks?: number | null
  itemsCompleted?: number
  totalItems?: number
  worksCompleted?: number
  totalWorks?: number
}

export interface LegacyPpcRow extends LegacyPpcWeek {
  periodKey: string
  projectWeek: number
}

export const legacyPpcPeriodKey = (longNumber?: number): string => {
  const value = `${longNumber || ''}`
  if (!/^\d{6}$/.test(value)) return ''
  return `${value.slice(0, 4)}-W${value.slice(4)}`
}

export const normalizeLegacyPpcWeeks = (
  weeks: LegacyPpcWeek[],
  from?: string,
  to?: string,
): LegacyPpcRow[] => weeks.map((week, index) => ({
  ...week,
  periodKey: legacyPpcPeriodKey(week.longNumber),
  projectWeek: index + 1,
})).filter((week) => (
  (!from || week.periodKey >= from) && (!to || week.periodKey <= to)
))
